import React from 'react'
import SelectMultipleField from '../input/SelectMultipleField'
import useFetchData from '../../../hooks/useFetchData'

export const SelectMultipleFieldFlags = ({ id, onChange, name, value, error, disabled, fieldValue = '_id' }) => {
  const { isLoading, data, error: errorFetch } = useFetchData('setting/flags')

  return (
    <SelectMultipleField
      id={id}
      error={errorFetch || error}
      helperText={errorFetch || error}                    
      value={value}
      name={name}
      onChange={onChange}      
      options={data?.map(item => ({ value: item[fieldValue], label: item.name })) || []}
      placeholder="Choose a flag"
      loading={isLoading}
      disabled={isLoading || disabled}
    />  
  )
}
